import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
  MatBottomSheet,
} from '@angular/material/bottom-sheet';
import { HomeMemberResult } from 'src/app/core/model/api-response/cooking-story-model';
import { User } from 'src/app/core/model/user-model';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { CookingStoryMemberInviteConfirmComponent } from './cooking-story-member-invite-confirm/cooking-story-member-invite-confirm.component';

@Component({
  selector: 'app-cooking-story-members-invite',
  templateUrl: './cooking-story-members-invite.component.html',
  styleUrls: ['./cooking-story-members-invite.component.scss'],
})
export class CookingStoryMembersInviteComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: HomeMemberResult,
    private bottomSheetRef: MatBottomSheetRef<CookingStoryMembersInviteComponent>,
    private matBottomSheet: MatBottomSheet,
    private snackBarService: SnackBarService,
    private recipeService: RecipeService
  ) {}

  ngOnInit(): void {}
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
    this.recipeService.goToHomeMembers();
  }
  accept() {
    this.matBottomSheet.open(CookingStoryMemberInviteConfirmComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: this.data,
    });
  }
  getProfile(user: User) {
    if (user.avatar != '' && user.avatar) return user.avatar;
    if (user.sex == 'male') return 'assets/cookingbook/men.svg';
    return 'assets/cookingbook/women.svg';
  }
}
